type Props = {
  symbol: string;
  companyName?: string | null;
};

export const SymbolLabel = ({ symbol, companyName }: Props) => {
  const name = companyName?.trim();
  return (
    <>
      <span className="tp-symbol-ticker">{symbol}</span>
      {name ? <div className="tp-symbol-company">{name}</div> : null}
    </>
  );
};
